export { default } from "./colors";
